import {Component, OnInit} from '@angular/core';
import {InfoPageComponent} from '../../shared/components/info-page/info-page.component';
import {Nl2brPipe} from '../../shared/pipes/nl2br.pipe';
import {ActivatedRoute} from '@angular/router';
import {LangService} from '../../core/services/lang.service';
import {RecommendationsService} from '../../core/api/recommendations.service';
import {
  getRecommendationAddress,
  getRecommendationDescription,
  getRecommendationSubtitle,
  getRecommendationTitle, getRecommendationTopActions,
  Recommendation,
  Recommendations
} from '../../shared/models/recommendations.model';
import {NgForOf} from '@angular/common';
import {RoundButtonComponent} from '../../shared/components/round-button/round-button.component';

@Component({
  selector: 'app-trash',
  templateUrl: './recommendations-detail.component.html',
  styleUrls: ['./recommendations-detail.component.scss'],
  imports: [InfoPageComponent, Nl2brPipe, NgForOf, RoundButtonComponent]
})
export class RecommendationsDetailComponent implements OnInit {
  imageSrc = '';
  imageAlt?: string;
  subtitle?: string;
  text?: string;
  recommendation?: Recommendation;
  address?: string;
  topActions?: TopAction[];

  constructor(private route: ActivatedRoute,
              private recommendationsService: RecommendationsService,
              private langService: LangService
  ) {
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadRecommendation(parseInt(id));
    }
  }

  public loadRecommendation(id: number) {
    this.recommendationsService.getRecommendations().subscribe({
      next: (recommendations: Recommendations) => {
        this.recommendation = recommendations.find(recommendation => recommendation.id === id);
        if (this.recommendation) {
          this.address = getRecommendationAddress(this.recommendation);
          this.imageSrc = this.recommendation.image || '';
          this.imageAlt = getRecommendationTitle(this.recommendation);
          this.subtitle = getRecommendationSubtitle(this.recommendation);
          this.text = getRecommendationDescription(this.recommendation);
          this.topActions = getRecommendationTopActions(this.recommendation);
        }
      },
      error: (error) => {
        console.error('Error al obtener recomendación:', error);
      }
    });
  }

  protected open(href: string) {
    if (href.startsWith('tel:')) {
      window.location.href = href;
    } else {
      window.open(href, '_blank');
    }
  }
}
